// components/MobileNavigation/NavItemLink.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { getIcon } from './IconMapping';

interface NavItemLinkProps {
  item: {
    id: string;
    label: string;
    to: string;
  };
  activeItem: string;
  onNavClick: (itemId: string) => void;
}

const NavItemLink: React.FC<NavItemLinkProps> = ({ item, activeItem, onNavClick }) => {
  return (
    <Link
      to={item.to}
      onClick={() => onNavClick(item.id)}
      className={`flex items-center space-x-3 px-3 py-2.5 rounded-md transition-all duration-200 hover:bg-gray-50 ${
        activeItem === item.id
          ? 'text-navgreen hover:text-navgreen hover:bg-green-50 font-medium'
          : 'text-gray-700 hover:text-gray-900 font-normal'
      }`}
    >
      <span className={`${activeItem === item.id ? 'text-navgreen' : 'text-gray-500'}`}>
        {getIcon(item.id, item.label)}
      </span>
      <span className="text-sm flex-1">{item.label}</span>
    </Link>
  );
};

export default NavItemLink;